<template>
  <div class="w-100 mt-2">
    <!-- <b-container class="container-box"> -->
    <b-row class="no-gutters mt-1">
      <b-col class="px-3" lg="4">
        <b-row class="bg-white p-3">
          <b-col class="">
            <b-row class="">
              <b-col class="p-0">
                <label class="main-label">{{ $t("earning") }}</label>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="p-0">
                <label class="sacondary-label statement-label w-100">{{
                  $t("amtToRecieve")
                }}</label>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col cols="6" class="p-0 m-auto">
                <label class="main-label"
                  >฿ {{ openObject.closingBalance | numeral("0,0.00") }}</label
                >
              </b-col>
              <b-col cols="6" class="text-right p-0">
                <b-button
                  v-if="openObject.closingBalance > 0"
                  class="btn-main wd-btn"
                  @click="
                    confirmWithdraw(
                      openObject.closingBalance,
                      openObject.accountNumber,
                      openObject.bankName
                    )
                  "
                  >{{ $t("withdraw") }}</b-button
                >
                <b-button
                  v-else
                  class="btn-main wd-btn"
                  @click="showModalInvoice = true"
                  >{{ $t("invoice") }}</b-button
                >
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="p-0">
                <label class="main-label">{{ $t("paymentMethod") }}</label>
              </b-col>
            </b-row>
            <b-row class="py-3 bank-panel mt-1">
              <b-col class="" cols="3" sm="1" lg="3" xl="2">
                <img
                  src="@/assets/images/acct-statement.png"
                  class="finance-icon"
                  alt=""
                />
              </b-col>
              <b-col class="" cols="9">
                <div>
                  <label class="mb-0">{{ openObject.accountNumber }}</label>
                </div>
                <div>
                  <label class="sacondary-label statement-label">{{
                    openObject.bankName
                  }}</label>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="px-3" lg="8">
        <b-row class="bg-white p-3 finance-box">
          <b-col>
            <b-row>
              <b-col class="p-0" sm="3">
                <label class="main-label mt-2">{{
                  $t("statementStatus")
                }}</label>
              </b-col>
              <b-col class="p-0 my-1" cols="6" sm="12" lg="3">
                <datetime
                  :placeholder="$t('startDate')"
                  v-model="filter.StartDate"
                  @close="hanedleDateChange"
                  class="date-filter"
                ></datetime>
              </b-col>

              <b-col class="p-0 my-1" cols="6" sm="12" lg="3">
                <datetime
                  :placeholder="$t('endDate')"
                  @close="hanedleDateChange"
                  v-model="filter.EndDate"
                  class="date-filter"
                >
                </datetime>
              </b-col>
              <b-col
                sm="12"
                lg="3"
                class="d-flex justify-content-end px-0 px-lg-3"
              >
                <button
                  type="button"
                  class="btn btn-link px-2 py-1"
                  @click="onClearFilter()"
                >
                  {{ $t("clear") }}
                </button>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col class="p-0">
                <b-button-group
                  class="btn-group-status d-inline-flex d-inline-md-block"
                >
                  <b-button
                    :class="{
                      menuactive: isActive(1),
                    }"
                    @click="onGetStatus(1)"
                  >
                    {{ $t("open") }}
                  </b-button>
                  <b-button
                    :class="{ menuactive: isActive(3) }"
                    @click="onGetStatus(3)"
                  >
                    {{ $t("waitingForPayment") }}
                  </b-button>
                  <b-button
                    :class="{ menuactive: isActive(2) }"
                    @click="onGetStatus(2)"
                  >
                    {{ $t("paid") }}
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col> </b-col>
            </b-row>
            <div v-if="activeItem === 1">
              <b-row v-if="isLoading">
                <b-col class="text-center text-secondary border-nodate-top">
                  <div class="p-5">
                    <span>
                      {{ $t("loading") }}
                    </span>
                  </div>
                </b-col>
              </b-row>
              <div v-else>
                <b-row class="statement-panel" v-if="openObject.statementNumber">
                  <b-col>
                    <div>
                      <b-row class="">
                        <b-col class="p-0">
                          <b-button
                            v-b-toggle="'collapse-1'"
                            class="collapse-statement-btn py-3 px-0"
                          >
                            <span class="collapse-statement-btn-label">
                              {{ $t("statementNumber") }} :
                              {{ openObject.statementNumber }}
                            </span>

                            <font-awesome-icon
                              icon="chevron-right"
                              color="#575757"
                              class="icon mt-1 when-close"
                              :class="{ 'float-right': activeItem == 2 }"
                            />
                            <font-awesome-icon
                              icon="chevron-down"
                              color="#575757"
                              class="icon mt-1 when-open"
                              :class="{ 'float-right': activeItem == 2 }"
                            />

                            <div class="when-close">
                              <span class="statement-label">
                                {{ openObject.startDate | moment($formatDate) }} -
                                {{ openObject.endDate | moment($formatDate) }}
                              </span>
                            </div>
                          </b-button>

                          <b-collapse
                            :id="'collapse-1'"
                            class="collapse-statement"
                            :visible="activeItem == 1"
                          >
                            <PanelTab 
                              :item="openObject"
                              :indexTab="1"
                              :index="0"
                              :gotoTab="[[3, 1],[2, 1]]"
                              @onNavigate="onNavigate"
                            />
                          </b-collapse>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-col class="text-center text-secondary border-nodate-top">
                    <div class="p-5">
                      <span>
                        {{ $t("noData") }}
                      </span>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div v-if="activeItem === 3">
              <b-row v-if="isLoading">
                <b-col class="text-center text-secondary border-nodate-top">
                  <div class="p-5">
                    <span>
                      {{ $t("loading") }}
                    </span>
                  </div>
                </b-col>
              </b-row>
              <div v-else>
                <b-row
                  class="statement-panel"
                  v-if="statementLists.length > 0"
                >
                  <b-col>
                    <div v-for="(item, index) in statementLists" :key="index">
                      <b-row class="">
                        <b-col class="p-0">
                          <b-button
                            v-b-toggle="'collapse-3' + index"
                            class="collapse-statement-btn py-3 px-0"
                          >
                            <span class="collapse-statement-btn-label">
                              {{ $t("statementNumber") }} :
                              {{ item.statementNumber }}
                            </span>
                              <span class="px-1" v-if="item.InvoiceUrl"> | </span>
                                <a
                                  @click.stop=""
                                  :href="item.InvoiceUrl"
                                  class="text-underline pointer menuactive"
                                  target="_blank"
                                  v-if="item.InvoiceUrl"
                                  >{{ $t("downloadInvoice") }}</a
                                >
                            <font-awesome-icon
                              icon="chevron-right"
                              color="#575757"
                              class="icon mt-1 when-close"
                              :class="{ 'float-right': activeItem == 3 }"
                            />
                            <font-awesome-icon
                              icon="chevron-down"
                              color="#575757"
                              class="icon mt-1 when-open"
                              :class="{ 'float-right': activeItem == 3 }"
                            />

                            <div class="when-close">
                              <span class="statement-label">
                                {{ item.startDate | moment($formatDate) }} -
                                {{ item.endDate | moment($formatDate) }}
                              </span>
                            </div>
                          </b-button>
                          <b-collapse
                            :id="'collapse-3' + index"
                            class="collapse-statement"
                            :visible="index == 0"
                          >
                            <PanelTab 
                              :item="item"
                              :indexTab="3"
                              :index="index"
                              :gotoTab="[[1, 3],[2, 3]]"
                              @onNavigate="onNavigate"
                            />
                          </b-collapse>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-col class="text-center text-secondary border-nodate-top">
                    <div class="p-5">
                      <span>
                        {{ $t("noData") }}
                      </span>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div v-if="activeItem === 2">
              <b-row v-if="isLoading">
                <b-col class="text-center text-secondary border-nodate-top">
                  <div class="p-5">
                    <span>
                      {{ $t("loading") }}
                    </span>
                  </div>
                </b-col>
              </b-row>
              <div v-else>
                <b-row
                  class="statement-panel"
                  v-if="statementLists.length > 0"
                >
                  <b-col>
                    <div v-for="(item, index) in statementLists" :key="index">
                      <b-row class="">
                        <b-col class="p-0">
                          <b-button
                            v-b-toggle="'collapse-2' + index"
                            class="collapse-statement-btn-paid p-2 my-1"
                          >
                            <b-row no-gutters>
                              <b-col cols="4" class="px-3">
                                <span class="">
                                  ฿ {{ item.subtotal | numeral("0,0.00") }}
                                </span>

                                <div class="mt-2 statement-label">
                                  {{ item.startDate | moment($formatDate) }} -
                                  {{ item.endDate | moment($formatDate) }}
                                </div>
                              </b-col>
                              <b-col cols="3" class="border-left px-3">
                                <span>
                                  <label class="mb-1">{{
                                    item.accountNumber
                                  }}</label>
                                  <br />
                                  <label
                                    class="sacondary-label statement-label mb-0 mt-1"
                                    >{{ item.bankName }}</label
                                  >
                                </span>
                              </b-col>
                              <b-col cols class="border-left pl-3">
                                <div v-if="item.documentUrl">
                                  <a
                                    @click.stop=""
                                    :href="item.documentUrl"
                                    class="text-underline pointer menuactive f-14"
                                    target="_blank"
                                    >{{ $t("downloadSellerFeeInvoice") }}</a
                                  >
                                </div>
                                <div v-if="item.documentSellerGetfinUrl">
                                  <a
                                    @click.stop=""
                                    :href="item.documentSellerGetfinUrl"
                                    class="text-underline pointer menuactive f-14"
                                    target="_blank"
                                    >{{ $t("downloadInvoiceOther") }}</a
                                  >
                                </div>
                                <div v-if="item.InvoiceUrl">
                                  <a
                                    @click.stop=""
                                    :href="item.InvoiceUrl"
                                    class="text-underline pointer menuactive f-14"
                                    target="_blank"
                                    >{{ $t("downloadInvoice") }}</a
                                  >
                                </div>
                                <div class="mt-1 statement-label">{{ $t("statementNo") }}: {{item.statementNumber}}</div>
                              </b-col>
                              <b-col cols="1">
                                <font-awesome-icon
                                  icon="chevron-right"
                                  color="#575757"
                                  id="statement-icon"
                                  class="icon mt-1"
                                  :class="{ 'float-right': activeItem == 2 }"
                                />
                                <font-awesome-icon
                                  icon="chevron-down"
                                  color="#575757"
                                  id="statement-icon"
                                  class="icon mt-1"
                                  :class="{ 'float-right': activeItem == 2 }"
                                />
                              </b-col>
                            </b-row>
                          </b-button>
                          <b-collapse
                            :id="'collapse-2' + index"
                            class="collapse-statement"
                            :visible="index == 0"
                          >
                            <PanelTab 
                              :item="item"
                              :indexTab="2"
                              :index="index"
                              :gotoTab="[[1, 2],[2, 2]]"
                              @onNavigate="onNavigate"
                            />
                          </b-collapse>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-col class="text-center text-secondary border-nodate-top">
                    <div class="p-5">
                      <span>
                        {{ $t("noData") }}
                      </span>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- </b-container> -->

    <b-modal id="modal-1" hide-header hide-footer centered>
      <div class="modal-header">
        <button
          type="button"
          aria-label="Close"
          class="close p-0"
          @click="$bvModal.hide('modal-1')"
        >
          ×
        </button>
      </div>
      <div class="refund-table-box">
        <b-table
          striped
          responsive
          hover
          :items="openObject.refundOrders"
          :fields="fields"
          show-empty
          :empty-text="$t('noData')"
          class="table-list"
        >
          <template v-slot:cell(grandTotal)="data">
            <p class="m-0">฿ {{ data.item.grandTotal | numeral("0,0.00") }}</p>
          </template>
          <template v-slot:cell(invoiceNo)="data">
            <router-link :to="'/order/details/' + data.item.id">
              <span class="text-underline">
                {{ data.item.invoiceNo }}
              </span>
            </router-link>
          </template>
        </b-table>
      </div>
    </b-modal>

    <b-modal v-model="showModalInvoice" ref="DownloadModal" centered hide-header hide-footer>
      <div class="modal-header border-0">
        <h4>{{$t('invoice')}}</h4>
        <button type="button" aria-label="Close" class="close" @click="showModalInvoice = false">×</button>
      </div>
      <!-- <div class="text-center px-md-5 py-4">
        <p class="text-text font-weight-bold">{{$t('invoice')}}</p>
      </div> -->
      <div class="form-inline justify-content-center mt-2">
        <router-link to="/finance/order/0/2">
          <b-button class="mr-md-2 btn-modal px-5 mb-3 mb-md-0" :disabled="!$isLoading" variant="warning" >{{$t('viewInvoiceDetails')}}</b-button>
        </router-link>
        <b-button class="ml-md-2 btn-modal" variant="main" :disabled="!$isLoading || openObject.closingBalance >= 0" @click="createInvoice">{{$t('downloadInvoice')}}</b-button>
      </div>
    </b-modal>
    <a
      ref="invoiceUrl"
      @click.stop=""
      :href="invoiceUrl"
      target="_blank"
      style="color: #ebedef;"
      >.</a
    >
    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalAlertConfirm
      :msg="$t('confirmWithdraw')"
      :text="modalMessage"
      colorBtnConfirm="primary"
      :btnCancel="$t('no')"
      :btnConfirm="$t('yes')"
      ref="isModalAlertConfirm"
      @confirm="sentWithdrawRequest"
    />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import TaxTooltip from "./../components/Tooltip.vue";
import PanelTab from "./../components/PanelTab.vue";

export default {
  components: {
    ModalAlert,
    ModalAlertError,
    ModalAlertConfirm,
    ModalLoading,
    TaxTooltip,
    PanelTab
  },
  data() {
    return {
      amount: 23901.25,
      isDisable: false,
      activeItem: 1,
      statementLists: [],
      isBusy: false,
      modalMessage: "",
      paidLists: [],
      openObject: {},
      msg: "",
      filter: {
        StartDate: "",
        EndDate: "",
        perPage: 10,
        pageNo: 1,
      },
      filterWait: {
        StartDate: "",
        EndDate: "",
        perPage: 10,
        pageNo: 1,
      },
      fields: [
        {
          key: "invoiceNo",
          label: `${this.$t("invoiceNum")}`,
          class: "w-100px",
        },
        {
          key: "grandTotal",
          label: `${this.$t("grandtotal")}`,
          class: "w-100px",
        },
      ],
      showModalInvoice: false,
      invoiceUrl: "",
      isLoading: true
    };
  },
  created: async function () {
    await this.getList();
  },
  methods: {
    getList: async function () {
      this.isLoading = true;
      this.isBusy = true;
      this.isDisable = true;
      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/Finance/Open`,
        null,
        this.$headers,
        null
      );
      this.statementLists = [];
      if (resData.result == 1) {
        this.openObject = resData.detail;
        this.statementLists.push(resData.detail);
        if (this.openObject.grandTotal !== 0) {
          this.isDisable = false;
        }
        // this.rows = resData.detail.totalData;
        // this.statusList = resData.detail.overviewCount;

        this.isBusy = false;
        this.$isLoading = true;
      }
      this.isLoading = false;
    },
    getListWait: async function () {
      this.isLoading = true;
      this.isBusy = true;
      this.isDisable = true;
      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/Finance/Wait`,
        null,
        this.$headers,
        this.filterWait
      );
      if (resData.result == 1) {
        this.statementLists = resData.detail.dataList;
        if (this.statementLists.length > 0) {
          this.isBusy = false;
        }

        // this.rows = resData.detail.totalData;
        // this.statusList = resData.detail.overviewCount;
      }
      this.isLoading = false;
    },
    getPaidLists: async function () {
      this.isBusy = true;
      this.isLoading = true;

      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/Finance/Paid`,
        null,
        this.$headers,
        this.filter
      );
      if (resData.result == 1) {
        this.statementLists = resData.detail.dataList;
        if (this.statementLists.length > 0) {
          this.isBusy = false;
        }

        // this.rows = resData.detail.totalData;
        // this.statusList = resData.detail.overviewCount;
      }
      this.isLoading = false;
    },
    isActive: function (menuItem) {
      return this.activeItem == menuItem;
    },
    hanedleDateChange() {
      this.activeItem = 2;
      this.getPaidLists();
    },
    onGetStatus(flag) {
      this.activeItem = flag;
      if (flag == 1) this.getList();
      if (flag == 3) this.getListWait();
      if (flag == 2) this.getPaidLists();
    },
    onNavigate(id, tab, status) {
      this.$router.push(`/finance/order/${id}/${tab}/${status}`);
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.pageNo = 1;
        this.getList();
      }
    },
    onClearFilter() {
      this.filter.search = "";
      this.filter.pageNo = 1;
      this.filter.StartDate = null;
      this.filter.EndDate = null;

      this.getPaidLists();
    },
    btnSearch() {
      this.filter.pageNo = 1;
      this.getList();
    },
    confirmWithdraw(balance, accid, accname) {
      this.modalMessage =
        this.$t("withdrawreq") +
        " ฿ " +
        balance
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        this.$t("from") +
        accid +
        " " +
        accname +
        this.$t("withdrawreq2");
      this.$refs.isModalAlertConfirm.show();
    },
    sentWithdrawRequest: async function () {
      this.$refs.isModalAlertConfirm.hide();

      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/Finance/RequestWithdraw`,
        null,
        this.$headers,
        null
      );
      this.modalMessage = resData.message;
      if (resData.result == 1) {
        this.$refs.modalAlert.show();
      } else {
        this.$refs.modalAlertError.show();
      }
    },
    createInvoice: async function () {
      this.$refs.isModalAlertConfirm.hide();
      this.$isLoading = false;

      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/Finance/CreateInvoice`,
        null,
        this.$headers,
        null
      );
      if (resData.result == 1) {
        this.invoiceUrl = resData.detail;
        setTimeout(() => { 
          this.$refs.invoiceUrl.click();
        }, 1500);
        await this.getList();
      } else {
        this.modalMessage = resData.message;
        this.$refs.modalAlertError.show();
      }
      this.$isLoading = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.bank-panel {
  border: #ebebeb solid 1px;
}
.collapse-statement-btn {
  width: 100%;
  text-align: left;
  background-color: white;
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-top-color: #f1f1f1;
  color: #575757;
}
.collapse-statement-btn-paid {
  width: 100%;
  text-align: left;
  background-color: white;
  border-radius: 0;
  border: 1px solid #f1f1f1;

  color: #575757;
}
.statement-label {
  font-size: 14px;
}
.collapse-statement {
  background-color: #f1f1f1;
  color: #575757;
  font-size: 14px;
}
.border-nodate-top {
  border-top: 1px solid #f1f1f1;
}
.statement-panel {
  overflow-x: auto;
  max-height: calc(100vh / 0.5);
}
.collapse-element-border {
  border-bottom: 1px solid #ebebeb;
}
.collapse-statement-btn-label {
  color: #1085ff;
  font-size: 14px;
}
.collapsed > .when-open,
.not-collapsed > .when-close {
  display: none;
}
.collapsed > .row > .col-1 > .fa-chevron-down,
.not-collapsed > .row > .col-1 > .fa-chevron-right {
  display: none;
}

.collapse-statement-label-custom {
  font-size: 16px;
  font-weight: bold;
}
.payment-action {
  color: #1085ff;
  cursor: pointer;
}
.finance-icon {
  width: auto;
  height: 40px;
}
.date-statement-filter {
  background-color: #f8f8f8;
  border: 10px !important;
  color: #dbdbdb;
  width: 10px;
  height: 40px;
}
.finance-box {
  min-height: 65vh;
}
.wd-btn {
  background-color: #ffb300 !important;
  border-color: #ffb300 !important;
  min-width: auto;
}
.text-pink {
  color: #f03366;
}
.total-box {
  background-color: #707070;
  color: white;
  padding: 10px 2rem;
}
.refund-table-box {
  max-height: 500px;
  overflow-y: auto;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    background-color: white;
    border-color: white;
}
</style>
